<div class="table-wrapper">
  <div class="table-header">
    <div class="align-items-center flex">
      <h2>Support Management</h2>
      <div class="user-label">
        <img alt="support-menu-blue.svg" src="../../assets/images/support-menu-blue.svg" width="16">
        <span>{{totalRecords}}</span>
      </div>
    </div>
  </div>
  <p-table #dt [(selection)]="selectedSupport" [rowHover]="true" [rowsPerPageOptions]="[10,20,30]" [rows]="10"
  [showCurrentPageReport]="true" [value]="support" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  dataKey="id">
<ng-template pTemplate="header">
<tr>
  <!--<th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>-->
  <th id="submittedBy" pSortableColumn="phone">Submitted By</th>
  <th class="w-12rem" id="submittedDate"  pSortableColumn="submittedDate">Submitted Date</th>
  <th class="w-4" id="subject" pSortableColumn="phone">Subject</th>
  <th id="agency" pSortableColumn="phone">Agency</th>
  <th id="status" pSortableColumn="phone">Status</th>
<!--  <th pSortableColumn="phone">Date updated</th>-->
<!--  <th pSortableColumn="phone">Created By</th>-->
  <!-- <th id="options" style="width: 3rem"><img alt="vector.svg" src="assets/images/vector.svg"></th> -->
  <th id="actions">Actions</th>
</tr>
</ng-template>
<ng-template let-rowIndex="rowIndex" let-supportElement pTemplate="body">
<tr class="p-selectable-row">
  <!--<td>
   <p-tableCheckbox [value]="supportElement"></p-tableCheckbox>
  </td>-->
  <td (click)="onRowSelect(rowIndex)"><span>{{supportElement.userDetails.firstName + ' ' +  supportElement.userDetails.lastName }}</span><span class="gc-agency-handle">({{RoleEnum[supportElement.userDetails.defaultRole]}})</span></td>
  <td (click)="onRowSelect(rowIndex)"><span>{{supportElement.createdAt | date: dateAndTimeFormat}}</span></td>
  <td (click)="onRowSelect(rowIndex)"><span>{{supportElement.subject | truncate:40}}</span></td>
  <td (click)="onRowSelect(rowIndex)"><span>{{supportElement.agencyDetails.name}}</span></td>
  <td (click)="onRowSelect(rowIndex)"> <span [ngClass]="{'resolved': supportElement.ticketStatus === 'Resolved', 'un-resolved': supportElement.ticketStatus === 'Unresolved'}">{{supportElement.ticketStatus}}</span></td>
<!--  <td (click)="onRowSelect(rowIndex)"><span>6/14/23</span></td>-->
<!--  <td (click)="onRowSelect(rowIndex)"><span>Admin</span></td>-->
  <td>
   <span class="p-column-title"></span>
   <button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu" mat-icon-button>
     <mat-icon>more_horiz</mat-icon>
   </button>
   <mat-menu #menu="matMenu">
     <button (click)="onRowSelect(rowIndex)" mat-menu-item>
      <em class="pi pi-info-circle"></em>
      <span>Details</span>
     </button>
     <ng-container *ngIf="supportElement.ticketStatus">
      <button (click)="toggleStatus(supportElement)" mat-menu-item>
        <em class="pi pi-info-circle"></em>
        <span>{{ supportElement.ticketStatus === 'Resolved' ? 'Unresolved' : 'Resolved' }}</span>
       </button>
    </ng-container>
   </mat-menu>
  </td>
</tr>
</ng-template>
<ng-template pTemplate="emptymessage">
<tr>
<td colspan="8" style="text-align: center">
       <span>
           <em class="pi pi-exclamation-circle mr-2"></em>
             No Support data found
       </span>
</td>
</tr>
</ng-template>
</p-table>
<div>
  <p-paginator #paginator (onPageChange)="paginate($event)" [rowsPerPageOptions]="rowsPerPageOptions" [rows]="noOfRecordPerRow" [totalRecords]="totalRecords" styleClass="gc-paginator"
  ></p-paginator>
</div>
</div>


<p-sidebar (onHide)="display = false" [(visible)]="display" [showCloseIcon]="false" position="right">
  <ng-template pTemplate="header">
    <div class="align-items-center flex justify-content-between w-full">
      <h2 class="gc-form-heading">Support Query</h2>
      <span (click)="display = false" class="cursor-pointer"><em class="pi pi-times"></em></span>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="SQ-popup-conent">
      <div class="SQ-content-inner">
        <div class="flex gap-3"><label>Submitted By:</label><span>{{support[selectedIndex]?.userDetails.firstName}} {{support[selectedIndex]?.userDetails.lastName}}</span><span class="gc-agency-handle">({{RoleEnum[support[selectedIndex]?.userDetails.defaultRole]}})</span></div>
        <div class="flex gap-3"><label>Email:</label><span>{{support[selectedIndex]?.email}}</span></div>
        <div class="flex gap-3" *ngIf="support[selectedIndex]?.fileUpload"><label>File:</label><span><img src="{{support[selectedIndex]?.fileUpload}}" alt="{{support[selectedIndex]?.subject}}"></span></div>
        <div class="flex gap-3"><label>Creation Date:</label><span>{{support[selectedIndex]?.createdAt | date: 'short'}}</span></div>
        <div class="flex gap-3"><label>Subject:</label><span>{{support[selectedIndex]?.subject}}</span></div>
        <div class="flex gap-3"><label>Description:</label><span>{{support[selectedIndex]?.description}}</span></div>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="gc-slide-footer flex justify-content-end gap-4">
      <button (click)="display = false" class="btn-cancel" label="Cancel" pButton></button>
    </div>
  </ng-template>
</p-sidebar>
